// the back does not have a defined string so by default it takes a code "44e1ec68e2a43f32741cbd4cb4d77c79e28d6a5c".
export enum SelectImage {
  DELETE_CODE = "44e1ec68e2a43f32741cbd4cb4d77c79e28d6a5c"
}
